import type React from 'react';
import styled from 'styled-components';

import type { ContentData } from 'app/ui/components/molecules/content-item-areas-wrapper';
import LessonSectionBreakdown from 'app/ui/components/molecules/whiteboard-slide/section-breakdown';

type LessonOverviewProps = {
  sectionsData: ContentData[];
};

const SectionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(4)};

  ${({ theme: { media } }) => `${media.medium(
    () => `
        flex-direction: row;
    `,
  )}
  `};
`;

const LessonOverview: React.FC<LessonOverviewProps> = ({ sectionsData }) => (
  <SectionsContainer>
    {sectionsData.map((sectionData) => (
      <LessonSectionBreakdown sectionData={sectionData} isOverviewMode={true} key={sectionData.id} />
    ))}
  </SectionsContainer>
);

export default LessonOverview;
